let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1AE9k")).then(() => parcelRequire('1CR3k'));